import React from 'react';
import classNames from 'classnames';
import Background from 'components/Background';
import MobileApi from 'lib/MobileApi';
import { getBackgroundPicture } from 'components/VerticalVideo/utils';
import styles from './styles.module.scss';

/**
 * Format the given number of seconds into a string representation of minutes and seconds.
 * @param {number} seconds - The number of seconds to format.
 * @returns {string} The formatted string representation of minutes and seconds.
 */
const formatSeconds = (seconds) => {
  const totalSeconds = Math.round(seconds);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 *
 * @param {object} props
 * @param {object} props.item
 * @param {Function} props.onSelect - The function to handle the selection.
 * @param {string[]} props.packageVideoIds - The package video IDs.
 */
export const VideoCard = ({ item, onSelect, packageVideoIds }) => {
  const { item: innerItem, computedValues } = item;
  const { headline = '' } = computedValues || {};
  const { videoAssets } = innerItem;
  const duration = videoAssets[0].assetDuration;

  const title = (
    <div className={styles.vertVideoCardsTwoByThreeTitleLink}>
      <div
        className={styles.vertVideoCardsTwoByThreeTitle}
      >
        <span data-testid="card-title">
          {headline}
        </span>
      </div>
    </div>
  );

  const bottomOfVideo = (
    <div className={styles.videoMeta}>
      <span
        className={classNames(styles.caret, 'icon', 'icon-play')}
        aria-hidden="true"
        focusable="false"
        data-testid="caret"
        data-test="caret"
      />
      <span data-testid="card-duration" className={styles.duration}>{formatSeconds(duration)}</span>
    </div>
  );

  /**
   * Handles the click event on the video card.
   * if we don't have a native mobile bridge (result is a string),
   * we call the onSelect function to handle the selection.
   */
  const handleClick = () => {
    const result = MobileApi.viewShort(item?.id, packageVideoIds);
    if (typeof result !== 'string') {
      onSelect();
    }
  };

  return (
    <div
      className={styles.vertVideoCardsTwoByThreeContainer}
      role="button"
      tabIndex={0}
      data-testid="card-container"
      data-contentid={item?.id}
      onClick={() => handleClick()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleClick();
      }}
    >
      <Background
        imageUrl={getBackgroundPicture(computedValues)}
        useBackground
        styleOverride={{
          bgWrapper: styles.vertVideoCardsTwoByThreeBgWrapper,
          bgContent: styles.vertVideoCardsTwoByThreeBgContent,
          bgBackground: styles.vertVideoCardBackground,
          bgGradient: styles.vertVideoCardsTwoByThreeGradient,
        }}
      >
        {title}
        {bottomOfVideo}
      </Background>
    </div>
  );
};
